{
  "mar": {
    "title": "दवा प्रशासन रिकॉर्ड",
    "loading": "MAR लोड हो रहा है...",
    "emptyState": "इस रोगी के लिए कोई सक्रिय दवा नहीं",
    "loadError": "दवाएं लोड करने में विफल",
    "retry": "पुनः प्रयास",
    "previousDay": "पिछला दिन",
    "nextDay": "अगला दिन",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "शिफ्ट",
    "dayShiftHeader": "दिन की शिफ्ट (07:00 - 19:00)",
    "nightShiftHeader": "रात की शिफ्ट (19:00 - 07:00)",
    "newOrder": "नया दवा आदेश",
    "printMar": "MAR प्रिंट करें",
    "prnSection": "PRN दवाएँ",
    "filter": {
      "timeWindow": "समय खिड़की",
      "category": "श्रेणी",
      "status": "स्थिति",
      "scheduledOnly": "केवल निर्धारित"
    },
    "adminStatus": {
      "scheduled": "निर्धारित",
      "dueNow": "अब देय",
      "overdue": "देरी से",
      "administered": "दिया गया",
      "held": "रोका गया",
      "refused": "अस्वीकृत",
      "missed": "छूट गया"
    },
    "columns": {
      "medication": "दवा",
      "drug": "दवा",
      "doseRoute": "खुराक / मार्ग",
      "schedule": "अनुसूची",
      "scheduledTime": "निर्धारित समय",
      "givenTime": "दिए जाने का समय",
      "givenBy": "किसने दिया",
      "status": "स्थिति"
    },
    "actions": {
      "administer": "दें",
      "hold": "रोकें",
      "refuse": "अस्वीकार करें",
      "skip": "छोड़ें",
      "missed": "छूटा हुआ चिह्नित करें",
      "edit": "प्रशासन संपादित करें",
      "viewHistory": "इतिहास देखें",
      "givePrn": "PRN दें"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "उच्च चेतावनी",
      "indication": "संकेत: {{indication}}",
      "lastGiven": "अंतिम बार दिया: {{time}}",
      "lastGivenBy": "अंतिम बार दिया: {{time}} ({{user}} द्वारा)"
    },
    "orderBadge": {
      "active": "सक्रिय",
      "onHold": "रोका हुआ",
      "discontinued": "बंद किया गया"
    },
    "legend": "किंवदंती:",
    "summary": {
      "medsGivenToday": "आज दी गई दवाएँ: ",
      "ofTotal": "{{total}} में से {{given}}",
      "overdueCount_one": "{{count}} देरी से",
      "overdueCount_other": "{{count}} देरी से",
      "nextDue": "अगली देय: ",
      "nextDueAt": "{{medName}} {{time}} पर"
    },
    "tooltip": {
      "given": "({{time}} पर दिया गया)",
      "pending": "दर्ज किया जा रहा है… सर्वर से अभी पुष्टि नहीं हुई"
    },
    "doseModal": {
      "title": "खुराक दें",
      "doseGiven": "दी गई खुराक",
      "siteOfAdministration": "प्रशासन स्थल",
      "comments": "टिप्पणियाँ",
      "vitalsCheck": "प्रशासन-पूर्व जीवन-संकेत जाँच",
      "doubleCheck": "दो-नैदानिक सत्यापन",
      "verifier": "सत्यापनकर्ता",
      "confirm": "प्रशासन की पुष्टि करें"
    },
    "administerDialog": {
      "doseLabel": "खुराक",
      "routeLabel": "मार्ग",
      "siteLabel": "स्थल (यदि लागू हो)",
      "site": {
        "notApplicable": "लागू नहीं",
        "leftArm": "बायीं बाँह",
        "rightArm": "दायीं बाँह",
        "leftDeltoid": "बायीं डेल्टॉइड",
        "rightDeltoid": "दायीं डेल्टॉइड",
        "leftGluteal": "बायाँ नितंब",
        "rightGluteal": "दायाँ नितंब",
        "leftThigh": "बायीं जाँघ",
        "rightThigh": "दायीं जाँघ",
        "abdomen": "उदर"
      },
      "timeAdministered": "प्रशासन का समय",
      "administeredDateAria": "प्रशासन तिथि",
      "administeredTimeAria": "प्रशासन समय",
      "notesLabel": "टिप्पणियाँ",
      "notesPlaceholder": "वैकल्पिक टिप्पणियाँ..."
    },
    "prnWarning": {
      "title": "PRN अंतराल चेतावनी",
      "lastDoseHoursAgo": "पिछली खुराक {{hours}} घंटे पहले दी गई थी।",
      "minimumInterval": "न्यूनतम अंतराल {{hours}} घंटे है।",
      "lastAdministered": "पिछली बार दी गई: {{time}}",
      "justificationLabel": "जल्दी देने का औचित्य",
      "justificationRequired": "*",
      "justificationPlaceholder": "न्यूनतम अंतराल से पहले दवा देने का नैदानिक औचित्य दर्ज करें...",
      "cancel": "रद्द करें",
      "overrideContinue": "ओवरराइड कर जारी रखें"
    },
    "toast": {
      "administered": "दवा प्रशासित दर्ज की गई",
      "administerError": "प्रशासन दर्ज करने में विफल",
      "administerNotImplemented": "MAR प्रशासन रिकॉर्डिंग अभी उपलब्ध नहीं है",
      "held": "दवा रोकी गई",
      "refused": "रोगी की अस्वीकृति दर्ज की गई",
      "skipped": "दवा छोड़ी गई",
      "orderNotActive": "यह आदेश अब सक्रिय नहीं है (बंद, रद्द या पूर्ण) — दवा देना दर्ज नहीं किया जा सकता।"
    },
    "holdRefuseDialog": {
      "holdTitle": "दवा रोकें",
      "refuseTitle": "दवा अस्वीकार करें",
      "skipTitle": "दवा छोड़ें",
      "scheduledLabel": "निर्धारित: {{time}}",
      "holdReasonLabel": "रोकने का कारण",
      "refusalNotesLabel": "अस्वीकृति टिप्पणियाँ",
      "skipReasonLabel": "छोड़ने का कारण",
      "holdReasonPlaceholder": "रोकने का कारण दर्ज करें...",
      "refusalPlaceholder": "रोगी की अस्वीकृति दर्ज करें...",
      "skipPlaceholder": "छोड़ने का कारण दर्ज करें...",
      "cancel": "रद्द करें",
      "confirm": "पुष्टि करें"
    },
    "contextMenu": {
      "hold": "रोकें",
      "refuse": "अस्वीकार करें",
      "skip": "छोड़ें"
    },
    "holdReason": {
      "label": "रोकने का कारण",
      "options": {
        "patientNpo": "रोगी NPO (निराहार)",
        "vitalsOutOfRange": "जीवन-संकेत सीमा से बाहर",
        "patientRefused": "रोगी ने मना किया",
        "providerOrder": "चिकित्सक का रोकने का आदेश",
        "other": "अन्य"
      }
    },
    "give": {
      "title": "दें · {{medication}} {{dose}}",
      "scheduledLabel": "निर्धारित {{time}}",
      "patientLabel": "रोगी",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "रोगी आईडी: {{id}}",
      "medicationLabel": "दवा",
      "scanPatientPlaceholder": "रिस्टबैंड स्कैन करें",
      "scanPatientAria": "रोगी का रिस्टबैंड स्कैन करें",
      "scanMedicationPlaceholder": "दवा के पैकेट का बारकोड स्कैन करें",
      "scanMedicationAria": "दवा का पैकेट स्कैन करें",
      "patientMismatch": "यह रिस्टबैंड इस रोगी का नहीं है। दवा न दें।",
      "medicationMismatch": "यह पैकेट आदेशित दवा नहीं है। दवा न दें।",
      "notScannable": "स्कैन से सत्यापन संभव नहीं — इस आदेश के लिए कोई बारकोड दर्ज नहीं है",
      "__review_notScannable": "Barcode scan-verification wording — confirm this reads as \"no barcode on file\", not \"wrong drug\" — needs clinical translator review",
      "overrideReason": "बिना स्कैन किए दवा देने का कारण",
      "overrideReasonPlaceholder": "जैसे: रिस्टबैंड क्षतिग्रस्त; बिना बारकोड वाली मिश्रित खुराक",
      "pharmacyOverride": "फ़ार्मेसी ने इस उच्च चेतावनी दवा का सत्यापन नहीं किया है",
      "__review_pharmacyOverride": "Override = proceed with a recorded reason, not cancel/ignore — needs clinical translator review",
      "pharmacyOverridePlaceholder": "यह खुराक फ़ार्मेसी समीक्षा की प्रतीक्षा क्यों नहीं कर सकती?",
      "timeLabel": "समय",
      "detailsEdit": "संपादित करें",
      "detailsDone": "पूर्ण",
      "confirmLabel": "ये विवरण आदेश और मेरे पास मौजूद खुराक से मेल खाते हैं",
      "cancel": "रद्द करें",
      "submit": "दें",
      "witness": {
        "banner": "उच्च चेतावनी — दूसरी नर्स द्वारा साक्षी सत्यापन आवश्यक",
        "__review_banner": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "usernameLabel": "दूसरी नर्स का उपयोगकर्ता नाम",
        "passwordLabel": "पासवर्ड",
        "verify": "सत्यापित करें",
        "verifying": "सत्यापित किया जा रहा है…",
        "verified": "दूसरी नर्स द्वारा साक्षी सत्यापन हुआ",
        "__review_verified": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "rejected": "प्रमाण-पत्र पहचाने नहीं गए।",
        "overrideLabel": "साक्षी सत्यापन संभव नहीं? दूसरी नर्स की जाँच के बिना दवा दें — कारण",
        "__review_overrideLabel": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "overridePlaceholder": "यह खुराक स्वतंत्र दोहरी जाँच की प्रतीक्षा क्यों नहीं कर सकती?"
      },
      "refusal": {
        "wrongPatient": "ग़लत रोगी — स्कैन किया गया रिस्टबैंड इस आदेश से मेल नहीं खाता। दवा न दें।",
        "wrongMedication": "ग़लत दवा — स्कैन किया गया पैकेट आदेशित दवा से मेल नहीं खाता। दवा न दें।",
        "scanRequired": "रिस्टबैंड और दवा स्कैन करें, या न स्कैन करने का कारण दें।",
        "pharmacyVerificationRequired": "फ़ार्मेसी ने इस आदेश का सत्यापन नहीं किया है। सत्यापन की प्रतीक्षा करें, या प्रतीक्षा न कर पाने का कारण दर्ज करें।",
        "doubleCheckRequired": "इस आदेश की दूसरी नर्स द्वारा दोहरी जाँच नहीं हुई है। साक्षी सत्यापन कराएँ, या प्रतीक्षा न कर पाने का कारण दर्ज करें।",
        "doubleCheckSelf": "आप अपनी ही दवा देने का साक्षी सत्यापन नहीं कर सकते। दूसरी नर्स को यह खुराक सत्यापित करनी होगी।"
      },
      "dispense": {
        "handedOver": "{{quantity}} {{time}} पर सौंपा गया",
        "label": "फ़ार्मेसी वितरण",
        "none": "इस आदेश के लिए कोई वितरण दर्ज नहीं",
        "pending": "वितरण दर्ज, अभी सौंपा नहीं गया",
        "prepared": "{{quantity}} {{time}} पर तैयार किया गया",
        "unavailable": "वितरण की जाँच नहीं हो सकी — रिकॉर्ड तक नहीं पहुँचा जा सका"
      }
    }
  },
  "status": {
    "active": "सक्रिय",
    "held": "रोका गया",
    "discontinued": "बंद किया गया",
    "completed": "पूर्ण",
    "refused": "अस्वीकृत",
    "missed": "छूट गया",
    "given": "दिया गया"
  },
  "route": {
    "po": "मौखिक",
    "iv": "अंतःशिरा",
    "im": "अंतःपेशीय",
    "sc": "त्वचा के नीचे",
    "in": "अंतःनासिक",
    "pr": "गुदा मार्ग से",
    "sl": "जिह्वा के नीचे",
    "top": "बाह्य प्रयोग",
    "neb": "नेबुलाइज़ेशन",
    "pv": "योनि मार्ग से",
    "ng": "नासोगैस्ट्रिक",
    "ophthalmic": "नेत्र",
    "transdermal": "त्वचा के पार"
  },
  "frequency": {
    "bid": "दिन में दो बार",
    "tid": "दिन में तीन बार",
    "qid": "दिन में चार बार",
    "qd": "दिन में एक बार",
    "qhs": "सोते समय",
    "prn": "आवश्यकता पर (PRN)",
    "stat": "तत्काल (STAT)",
    "continuous": "निरंतर"
  },
  "formulary": {
    "title": "औषधि सूची",
    "searchPlaceholder": "दवा के नाम, जेनेरिक नाम या कोड से खोजें...",
    "clearSearch": "खोज साफ़ करें",
    "category": {
      "all": "सभी",
      "analgesic": "दर्द निवारक",
      "antibiotic": "एंटीबायोटिक",
      "antifungal": "एंटीफंगल",
      "antiviral": "एंटीवायरल",
      "cardiac": "हृदय रोग",
      "endocrine": "अंतःस्रावी",
      "gi": "जठरांत्र",
      "neurological": "तंत्रिका तंत्र",
      "psychiatric": "मानसिक रोग",
      "respiratory": "श्वसन तंत्र",
      "other": "अन्य"
    },
    "columns": {
      "medication": "दवा",
      "genericName": "जेनेरिक नाम",
      "form": "रूप",
      "strength": "शक्ति",
      "route": "मार्ग",
      "status": "स्थिति",
      "schedule": "नियंत्रण श्रेणी"
    },
    "highAlertBadge": "उच्च-जोखिम वाली दवा",
    "highAlertTag": "उच्च जोखिम",
    "status": {
      "preferred": "अनुशंसित",
      "restricted": "प्रतिबंधित",
      "nonFormulary": "सूची से बाहर"
    },
    "loading": "औषधि सूची लोड हो रही है...",
    "loadError": "औषधि सूची लोड नहीं हो सकी",
    "empty": "कोई दवा नहीं मिली।",
    "pagination": {
      "showing": "कुल {{total}} में से {{from}}-{{to}} दिखाई जा रही हैं",
      "page": "पृष्ठ {{page}} / {{totalPages}}",
      "previous": "पिछला पृष्ठ",
      "next": "अगला पृष्ठ"
    },
    "details": {
      "close": "विवरण बंद करें",
      "genericName": "जेनेरिक नाम",
      "category": "श्रेणी",
      "formStrength": "रूप / शक्ति",
      "route": "मार्ग",
      "formularyStatus": "औषधि सूची स्थिति",
      "deaSchedule": "DEA नियंत्रण श्रेणी",
      "indications": "संकेत",
      "contraindications": "विपरीत-संकेत",
      "interactions": "औषधि अंतःक्रिया",
      "sideEffects": "दुष्प्रभाव",
      "dosageGuidelines": "खुराक दिशानिर्देश",
      "specialPopulations": "विशेष आबादी",
      "storage": "भंडारण"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "फार्मासिस्ट सत्यापन कतार",
    "subtitle": "लंबित दवा आदेशों की समीक्षा और सत्यापन करें",
    "pendingCount": "{{count}} लंबित",
    "refresh": "ताज़ा करें",
    "searchPlaceholder": "दवा, रोगी का नाम या MRN से खोजें...",
    "priority": {
      "all": "सभी प्राथमिकताएँ",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "नियमित",
      "scheduled": "अनुसूचित"
    },
    "loadError": "दवा कतार लोड नहीं हो सकी",
    "retry": "पुनः प्रयास",
    "empty": {
      "title": "सब निपट गया",
      "description": "सत्यापन के लिए कोई लंबित दवा आदेश नहीं है।"
    },
    "columns": {
      "patient": "रोगी",
      "medication": "दवा",
      "doseRouteFreq": "खुराक / मार्ग / आवृत्ति",
      "priority": "प्राथमिकता",
      "orderingProvider": "आदेश देने वाला चिकित्सक",
      "ordered": "आदेश समय",
      "actions": "क्रियाएँ"
    },
    "row": {
      "unknown": "अज्ञात",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "नियंत्रित {{schedule}}",
      "providerFallback": "चिकित्सक #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "सत्यापित करें",
      "verifyTooltip": "इस दवा आदेश को सत्यापित करें",
      "reject": "अस्वीकार करें",
      "rejectTooltip": "अस्वीकार और बंद करें",
      "confirmReject": "पुष्टि करें",
      "cancelReject": "रद्द करें",
      "rejectReasonPlaceholder": "अस्वीकृति का कारण..."
    },
    "toast": {
      "verifySuccess": "दवा #{{id}} सत्यापित",
      "verifyError": "दवा सत्यापित करने में विफल",
      "rejectSuccess": "दवा #{{id}} अस्वीकृत और बंद",
      "rejectError": "दवा अस्वीकार करने में विफल",
      "rejectReasonRequired": "कृपया अस्वीकृति का कारण बताएँ",
      "notIndependent": "निर्धारक अपना ही आदेश सत्यापित नहीं कर सकता।",
      "overrideSuccess": "आदेश {{id}} फार्मासिस्ट सत्यापन के बिना सक्रिय किया गया",
      "overrideError": "ओवरराइड दर्ज नहीं हो सका",
      "overrideReasonRequired": "ओवरराइड के लिए कारण कोड और औचित्य दोनों आवश्यक हैं"
    },
    "verifyDialog": {
      "title": "दवा आदेश सत्यापित करें",
      "instruction": "पूरी की गई प्रत्येक जाँच की पुष्टि करें। चारों आवश्यक हैं — आंशिक समीक्षा सत्यापन नहीं है।",
      "checks": {
        "allergy": "मैंने रोगी की एलर्जी के विरुद्ध समीक्षा की",
        "interaction": "मैंने दवा-दवा अंतःक्रिया की समीक्षा की",
        "duplicateTherapy": "मैंने दोहरी चिकित्सा की समीक्षा की",
        "doseRange": "मैंने इस रोगी के लिए खुराक की समीक्षा की"
      },
      "cancel": "रद्द करें",
      "confirm": "आदेश सत्यापित करें"
    },
    "override": {
      "action": "ओवरराइड",
      "confirm": "ओवरराइड दर्ज करें",
      "cancel": "रद्द करें",
      "tooltip": "फार्मासिस्ट सत्यापन के बिना आगे बढ़ें। कारण दर्ज होता है; उच्च-सतर्कता दवा की फार्मेसी जाँच की पूर्ति नहीं करता।",
      "codeLabel": "ओवरराइड कारण कोड",
      "codePlaceholder": "कारण चुनें…",
      "justificationLabel": "ओवरराइड औचित्य",
      "justificationPlaceholder": "फार्मेसी समीक्षा के बिना क्यों आगे बढ़ रहे हैं?",
      "code": {
        "pharmacyClosed": "फार्मेसी बंद",
        "urgentClinicalNeed": "तत्काल नैदानिक आवश्यकता",
        "pharmacyUnreachable": "फार्मेसी से संपर्क नहीं"
      }
    },
    "clarify": {
      "action": "स्पष्टीकरण",
      "tooltip": "फार्मेसी ने इस आदेश को अलग दर्ज किया है। दवा देने से पहले इसे सुलझाएँ।",
      "heading": "फार्मेसी ने इसे अलग दर्ज किया",
      "holding": "(आदेश रोकता है)",
      "upheld": "आदेश यथावत",
      "upheldTooltip": "मूल आदेश सही है; लिखे अनुसार वितरित करें।",
      "amended": "मैंने संशोधित किया",
      "amendedTooltip": "दर्ज करें कि आदेश बदला गया है।",
      "adopt": "फार्मेसी का संस्करण अपनाएँ",
      "adoptTooltip": "सहयोगी अभ्यास समझौते या P&T प्रोटोकॉल के तहत दर्ज संस्करण स्वीकार करें।",
      "close": "बंद करें",
      "toast": {
        "resolved": "स्पष्टीकरण सुलझ गया; आदेश सत्यापन हेतु लौटा",
        "error": "स्पष्टीकरण नहीं सुलझ सका"
      }
    }
  },
  "reconciliation": {
    "title": "औषधि सामंजस्य",
    "subtitle": "{{patient}} | {{mrn}} | भेंट #{{encounter}}",
    "complete": "सामंजस्य पूर्ण करें",
    "loading": "दवाएँ लोड हो रही हैं...",
    "column": {
      "home": "घर की दवाएँ",
      "inpatient": "आंतरिक रोगी दवाएँ",
      "discharge": "डिस्चार्ज दवाएँ"
    },
    "emptyHome": "घर की कोई दवा नहीं मिली।",
    "emptyInpatient": "आंतरिक रोगी दवाएँ नहीं मिलीं।",
    "emptyDischarge": "अभी तक कोई डिस्चार्ज दवा नहीं। अन्य कॉलम से दवा जारी रखें या संशोधित करें।",
    "changedFromHome": "घर की दवा से बदला हुआ",
    "action": {
      "continue": "जारी रखें",
      "modify": "संशोधित करें",
      "discontinue": "बंद करें",
      "discontinueShort": "D/C",
      "newOrder": "नया"
    },
    "addToDischarge": "डिस्चार्ज में जोड़ें",
    "remove": "हटाएँ",
    "modifyForm": {
      "title": "दवा संशोधित करें",
      "dose": "खुराक",
      "route": "मार्ग",
      "frequency": "आवृत्ति",
      "dosePlaceholder": "जैसे 500mg",
      "routePlaceholder": "जैसे PO",
      "frequencyPlaceholder": "जैसे BID",
      "cancel": "रद्द करें",
      "save": "सहेजें"
    },
    "back": "वापस",
    "toast": {
      "completed": "औषधि सामंजस्य पूर्ण हुआ",
      "completeError": "सामंजस्य पूर्ण करने में विफल",
      "atLeastOne": "पूर्ण करने से पहले कृपया कम से कम एक दवा का सामंजस्य करें"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "खुराक कैलकुलेटर",
      "weightLabel": "रोगी का वजन (kg) *",
      "heightLabel": "ऊंचाई (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "उदा. 70",
      "heightPlaceholder": "उदा. 170",
      "gfrPlaceholder": "वैकल्पिक",
      "bsaLabel": "गणना की गई BSA (Mosteller):",
      "calculate": "खुराक की गणना करें",
      "error": "खुराक की गणना विफल रही। बैकएंड में इस दवा का खुराक डेटा नहीं हो सकता है।",
      "renalAdjustment": "गुर्दे का समायोजन:",
      "originalDose": "मूल खुराक:",
      "min": "न्यूनतम:",
      "max": "अधिकतम:",
      "recommended": "अनुशंसित: {{dose}} {{unit}}",
      "apply": "खुराक लागू करें",
      "method": {
        "weightBased": "वजन-आधारित",
        "bsaBased": "BSA-आधारित",
        "flat": "निश्चित खुराक",
        "renalAdjusted": "गुर्दे-समायोजित"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "दवा लिखें",
    "submit": "लिखें",
    "navButton": "दवा लिखें",
    "noActiveEncounter": "प्रिस्क्रिप्शन को एक सक्रिय मुलाकात से जोड़ा जाना चाहिए। लिखने से पहले इस रोगी की मुलाकात खोलें या भर्ती करें।",
    "fields": {
      "medication": "दवा",
      "dose": "खुराक",
      "doseUnit": "इकाई",
      "route": "मार्ग",
      "frequency": "आवृत्ति",
      "frequencyDescription": "आवृत्ति विवरण",
      "duration": "अवधि",
      "durationUnit": "अवधि इकाई",
      "totalDoses": "कुल खुराक",
      "isPrn": "आवश्यकतानुसार (PRN)",
      "prnIndication": "PRN संकेत",
      "administrationInstructions": "प्रशासन निर्देश",
      "patientInstructions": "रोगी निर्देश",
      "quantityDispensed": "वितरित मात्रा",
      "refillsAuthorized": "अधिकृत रिफिल",
      "allowSubstitution": "जेनेरिक प्रतिस्थापन की अनुमति दें",
      "pharmacyNotes": "फार्मेसी टिप्पणी",
      "indication": "संकेत",
      "clinicalIndication": "नैदानिक संकेत",
      "priority": "प्राथमिकता"
    },
    "sections": {
      "drug": "दवा",
      "dosing": "खुराक",
      "durationPrn": "अवधि और आवश्यकतानुसार (PRN)",
      "instructions": "निर्देश",
      "dispensing": "वितरण",
      "clinical": "नैदानिक"
    },
    "doseUnitPlaceholder": "जैसे mg",
    "drugSearch": {
      "placeholder": "फॉर्मूलरी खोजें…",
      "noResults": "कोई मेल खाती फॉर्मूलरी दवा नहीं",
      "clear": "चयन हटाएं",
      "catalogRequired": "निर्धारित करने के लिए फॉर्मूलरी से दवा चुनें",
      "catalogOnly": "केवल फॉर्मूलरी दवाएं निर्धारित की जा सकती हैं, ताकि हर सुरक्षा जांच चल सके।",
      "controlledBadge": "नियंत्रित — अनुसूची {{schedule}}",
      "controlledTag": "नियंत्रित",
      "highAlertBadge": "उच्च-जोखिम वाली दवा",
      "highAlertTag": "उच्च जोखिम",
      "contraindications": "निषेध: {{text}}"
    },
    "route": {
      "oral": "मौखिक (PO)",
      "iv": "अंतःशिरा (IV)",
      "subcutaneous": "त्वचा के नीचे (SC)",
      "intramuscular": "मांसपेशी में (IM)",
      "topical": "सामयिक",
      "inhalation": "साँस द्वारा",
      "rectal": "मलाशय (PR)",
      "ophthalmic": "नेत्र",
      "transdermal": "त्वचा के पार"
    },
    "frequency": {
      "QD": "दिन में एक बार (QD)",
      "BID": "दिन में दो बार (BID)",
      "TID": "दिन में तीन बार (TID)",
      "QID": "दिन में चार बार (QID)",
      "Q4H": "हर 4 घंटे (Q4H)",
      "Q6H": "हर 6 घंटे (Q6H)",
      "Q8H": "हर 8 घंटे (Q8H)",
      "Q12H": "हर 12 घंटे (Q12H)",
      "QHS": "सोते समय (QHS)",
      "PRN": "आवश्यकतानुसार (PRN)",
      "STAT": "तुरंत (STAT)"
    },
    "durationUnit": {
      "days": "दिन",
      "weeks": "सप्ताह",
      "months": "महीने",
      "doses": "खुराक"
    },
    "priority": {
      "routine": "नियमित",
      "asap": "यथाशीघ्र",
      "stat": "तत्काल"
    },
    "validation": {
      "prnIndicationRequired": "आवश्यकतानुसार आदेश के लिए PRN संकेत आवश्यक है"
    },
    "contextBar": {
      "ariaLabel": "प्रिस्क्राइबिंग संदर्भ",
      "allergies": {
        "label": "एलर्जी",
        "none": "कोई ज्ञात एलर्जी नहीं",
        "severe": "गंभीर"
      },
      "weight": {
        "label": "वज़न",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "दर्ज नहीं"
      },
      "renal": {
        "label": "गुर्दा कार्य",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "गुर्दा कार्य अज्ञात",
        "source": {
          "reported": "रिपोर्ट किया गया",
          "computed": "गणना किया गया",
          "unknown": "अज्ञात"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "दवा निर्धारित कर दी गई",
      "error": "ऑर्डर दर्ज नहीं किया जा सका। कृपया पुनः प्रयास करें।",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "सुरक्षा परामर्श के साथ निर्धारित",
      "continue": "जारी रखें"
    },
    "safetyReview": {
      "title": "सुरक्षा समीक्षा आवश्यक",
      "proceed": "ओवरराइड करें और लिखें",
      "cancel": "रद्द करें",
      "reasonPrompt": "ओवरराइड का कारण चुनें…",
      "freeTextLabel": "अतिरिक्त विवरण",
      "freeTextPlaceholder": "नैदानिक संदर्भ जोड़ें (वैकल्पिक)",
      "hardBlockNote": "इस अवरोध को ओवरराइड नहीं किया जा सकता।",
      "cannotOverride": "यह पर्चा आगे नहीं बढ़ सकता — एक या अधिक अवरोध ओवरराइड नहीं किए जा सकते।",
      "blockKind": {
        "cds_contraindication": "निषेध",
        "cds_unavailable": "सुरक्षा जाँच उपलब्ध नहीं",
        "renal_contraindication": "गुर्दा निषेध",
        "dose_range": "अनुशंसित सीमा से बाहर खुराक",
        "pregnancy_contraindication": "गर्भावस्था जोखिम",
        "unknown": "अतिरिक्त सुरक्षा अवरोध"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "इतिहास की मैन्युअल समीक्षा की गई",
        "NO_KNOWN_RISK_THIS_PATIENT": "इस रोगी के लिए कोई ज्ञात जोखिम नहीं",
        "URGENT_CLINICAL_NEED": "तत्काल नैदानिक आवश्यकता",
        "OTHER": "अन्य (निर्दिष्ट करें)",
        "BENEFIT_OUTWEIGHS_RISK": "लाभ जोखिम से अधिक है",
        "DOSE_REDUCED_PER_PROTOCOL": "प्रोटोकॉल के अनुसार खुराक कम की गई",
        "EGFR_NOT_REPRESENTATIVE": "eGFR प्रतिनिधि नहीं है",
        "SPECIALIST_ADVICE": "विशेषज्ञ की सलाह",
        "PATIENT_TOLERANT": "रोगी इस खुराक को सहन करता है",
        "SPECIALIST_PROTOCOL": "विशेषज्ञ प्रोटोकॉल के अनुसार",
        "TITRATING_TO_EFFECT": "प्रभाव के अनुसार समायोजन",
        "RANGE_NOT_APPLICABLE": "सीमा लागू नहीं",
        "STATUS_CONFIRMED_NEGATIVE": "गर्भावस्था की स्थिति नकारात्मक पुष्ट",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "लाभ भ्रूण जोखिम से अधिक",
        "CONTRACEPTION_CONFIRMED": "प्रभावी गर्भनिरोधक पुष्ट",
        "PREGNANCY_BEING_TERMINATED": "गर्भावस्था समाप्त की जा रही है"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
